import Component from 'component';
import VanillaModal from 'vanilla-modal';
import _template from 'lodash/template';
import _forEach from 'lodash/forEach';
import PerfectScrollbar from 'perfect-scrollbar';

class ExcerptsModal extends Component{
  constructor(el, config){
    super(el, config);

    this.modal = new VanillaModal({
      onBeforeOpen: () => this.onOpenModal(),
      onBeforeClose: () => this.removeModalContent()
    });
  }

  setupDefaults() {
    this.dom = {
      $body: $('body'),
      modal: '.wh-excerpts-modal'
    };

    this.bodyYPosition = 0;
  }

  addListeners() {
    this.dom.$body.on('click', '.wh-excerpts-trigger', ::this.openModal);
  }

  openModal(e) {
    e.preventDefault();

    this.onLoadData({
      id: $(e.currentTarget).data('book-id')
    });
  }

  onOpenModal() {
    this.bodyYPosition = $(window).scrollTop() * -1;
    $('body').css('top', `${this.bodyYPosition}px`);
  }

  removeModalContent() {
    this.scrollbarContent.destroy();
    this.scrollbarList.destroy();
    $(this.dom.modal).remove();
    $(window).scrollTop(this.bodyYPosition);
  }

  goToMenu(e) {
    e.preventDefault();
    this.dom.$modalContent.removeClass('view-content');
  }

  goToContent(e) {
    e.preventDefault();
    const $target = $(e.currentTarget);
    const itemKey = $target.data('excerpt-key');

    this.dom.$menuItem.removeClass('active');
    $target.parent().addClass('active');
    this.dom.$modalContent.addClass('view-content');

    this.dom.$content.html(
      `<h2 class="wh-excerpts-modal__title">${this.data[itemKey].Title}</h2>${this.data[itemKey].Content}`
    )
  }

  onLoadData(params){
    this.renderData(params)
      .catch(err => {
        console.error('There was an issue getting your results', err);
      });
  }

  async renderData(params){
    this.data = await this.getData(params);
    const tpl = _template(this.config.template, { imports: { _forEach } })({
      data: this.data
    });

    this.dom.$body.append(tpl);

    const $modalContent = $('.wh-excerpts-modal__content');

    this.dom = {
      ...this.dom,
      $modalContent,
      $backBtn: $modalContent.find('.wh-excerpts-modal__btn-back'),
      $menuItem: $modalContent.find('.wh-excerpts-modal-menu__item'),
      $content: $modalContent.find('.wh-excerpts-modal__main')
    };

    this.dom.$backBtn.on('click', ::this.goToMenu);
    this.dom.$modalContent.on('click', '.wh-excerpts-modal-menu__item a', ::this.goToContent);

    this.scrollbarContent = new PerfectScrollbar('.wh-excerpts-modal__main');
    this.scrollbarList = new PerfectScrollbar('.wh-excerpts-modal-menu');

    this.modal.open('#wh-excerpts-modal');
  }

  getData(params){
    return $.getJSON(
      this.config.endpoint,
      {
        ...params
      }
    );
  }
}


export default ExcerptsModal;



// WEBPACK FOOTER //
// ./src/js/components/book/ExcerptsModal.js